import { render, staticRenderFns } from "./accountApply.vue?vue&type=template&id=20204c14&scoped=true"
import script from "./accountApply.vue?vue&type=script&lang=js"
export * from "./accountApply.vue?vue&type=script&lang=js"
import style0 from "./accountApply.vue?vue&type=style&index=0&id=20204c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20204c14",
  null
  
)

export default component.exports